import { RequestsApi } from '../RequestsApi';

class SubscriptionApi extends RequestsApi {
    /**
     * The public tier catalog (HORO-10504) — what each tier is entitled to,
     * with live SubscriptionPlan pricing populated on `entitlements.plans`.
     *
     * `X-FE-Handle-Errors` is load-bearing, not defensive habit. The route is
     * gated by SUBSCRIPTION_TIER_MODEL_V2 and a disabled flag answers 404, and
     * ResponseService turns any unhandled 404 into `window.location.replace`
     * back to the homepage. Without this header, running with the flag off
     * doesn't fall back to the static table — it ejects the visitor off /plans
     * entirely, with the console wiped on the way out.
     */
    async getTiers() {
        return await this.request('/subscriptions/tiers', 'get', {}, { 'X-FE-Handle-Errors': '1' });
    }
}

export default new SubscriptionApi();
